import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { OnDestroy } from "cv-ng-metadata/core";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import {
    ETLReportingSetDropdownOptions,
    ETLReportingSetReturnTypes
} from "../../../cxone-etl-reporting-set.model";

@Component({
    selector: "cv-cxone-reporting-substring-field",
    templateUrl: "./substring-field.component.html",
    styleUrls: ["./substring-field.component.scss"],
})
export class CxoneReportingSetSubstringFieldComponent implements OnInit, OnDestroy {
    @Output() back = new EventEmitter();
    @Output() addChilds = new EventEmitter();
    @Output() editExistItem = new EventEmitter();
    @Output() formChanged = new EventEmitter();

    @Input() set parentData(data) {
        this._parentData = data;
        const pattern = data?.pattern || "";

        if (this.substringForm) {
            this.substringForm.controls["pattern"].patchValue(pattern);
            this._parentData.isValid = this.checkIsValid();
        }
    }
    @Input() returnType: ETLReportingSetDropdownOptions;

    constructor(private cvLocalizationService: CVLocalizationService) { }

    public _parentData: any;
    public unsubscribeSubject: any;
    public patternPlaceholder = "";
    public addFieldPlaceholderText = "";
    public showIcon = true;
    public showFields = true;
    public substringForm: FormGroup;
    get parentData() {
        return this._parentData;
    }

    get pattern() {
        return this.substringForm.get("pattern").value;
    }

    async ngOnInit() {
        const pattern = this.parentData?.pattern || "";
        this.substringForm = new FormGroup({
            pattern: new FormControl({ value: "", disabled: false }, [Validators.required]),
        });
        this.substringForm.controls["pattern"].patchValue(pattern);
        if (this.parentData) {
            this.parentData.isValid = this.parentData.isValid || false;
        }

        await this.loadLocalization();
        this.unsubscribeSubject = this.substringForm.valueChanges.subscribe(
            (res) => {
                this.parentData.pattern = res?.pattern;
                this.parentData.isValid = this.checkIsValid();
                this.formChanged.emit(this._parentData);
            }
        );
        this.parentData.isValid = this.checkIsValid();
    }

    ngOnDestroy() {
        this.unsubscribeSubject.unsubscribe();
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("ETL_Reporting_Set");
        } catch {
            console.log("Failed to load localization for ETL_Reporting_Set");
        } finally {
            this.addFieldPlaceholderText = this.getLocalizationString(
                "Input_Field_Placeholder",
                "Add input"
            );
            this.patternPlaceholder = this.getLocalizationString(
                "Type_Regular_Expression",
                "Type regular expression"
            ); // to be given to cv team
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText(
            "ETL_Reporting_Set",
            key,
            defaultValue
        );
        return baseString;
    }

    public addInput() {
        this.showFields = false;
        this._parentData.isValid = this.checkIsValid();
        this.addChilds.emit(this.parentData);
    }

    public editInput(item) {
        this.editExistItem.emit(item);
    }

    public goBack(): void {
        this.back.emit(this.parentData);
    }

    public checkIsValid() {
        return (this.parentData.childs.length > 0) &&
            this.substringForm.valid &&
            (this.returnType && this.returnType.id == ETLReportingSetReturnTypes.TEXT);
    }
}

